// @ts-nocheck
import React from 'react';

function Catch(component, errorHandler) {
  // eslint-disable-next-line react/prop-types
  function Inner({ props, error }) {
    return <>{component(props, error)}</>;
  }
  return class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
      return { error };
    }

    componentDidCatch(error, errorInfo) {
      if (errorHandler) {
        errorHandler(error, errorInfo);
      }
    }

    render() {
      return <Inner props={this.props} error={this.state.error} />;
    }
  };
}

export default Catch;
